import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Admin = () => {
  const [name, setName] = useState("");
  const [file, setFile] = useState(null);
  const [flowers, setFlowers] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [category, setCategory] = useState("car");

  const navigate = useNavigate();

  // 🔐 PROTECT ADMIN
  useEffect(() => {
    const isAdmin = localStorage.getItem("isAdmin");
    if (!isAdmin) {
      navigate("/login");
    }

    const stored = JSON.parse(localStorage.getItem("flowers")) || [];
    setFlowers(stored);
  }, []);

  // 🔓 LOGOUT FUNCTION
  const handleLogout = () => {
    localStorage.removeItem("isAdmin");
    navigate("/login");
  };

  // ➕ ADD / UPDATE FLOWER
  const handleAdd = () => {
    if (!name || !file) {
      alert("Enter name & select image");
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      const newFlower = {
        name,
        image: reader.result
      };

      let updated = [...flowers];

      if (editIndex !== null) {
        updated[editIndex] = newFlower;
        alert("Flower Updated!");
      } else {
        updated.push(newFlower);
        alert("Flower Added!");
      }

      setFlowers(updated);
      localStorage.setItem("flowers", JSON.stringify(updated));

      setName("");
      setFile(null);
      setEditIndex(null);
    };

    reader.readAsDataURL(file);
  };

  // 📸 GALLERY UPLOAD
  const handleGalleryUpload = () => {
    if (!file) {
      alert("Select image");
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      const newImage = {
        url: reader.result,
        category: category
      };

      const existing = JSON.parse(localStorage.getItem("gallery")) || [];
      localStorage.setItem("gallery", JSON.stringify([...existing, newImage]));

      alert("📸 Uploaded to Gallery!");

      setFile(null);
    };

    reader.readAsDataURL(file);
  };

  // ❌ DELETE FLOWER
  const handleDelete = (index) => {
    const updated = flowers.filter((_, i) => i !== index);
    setFlowers(updated);
    localStorage.setItem("flowers", JSON.stringify(updated));
  };

  return (
    <div className="admin-container">

      {/* 🔓 LOGOUT BUTTON (FIXED POSITION) */}
      <button 
        className="btn"
        style={{ background: "black", marginBottom: "10px" }}
        onClick={handleLogout}
      >
        🔓 Logout
      </button>

      {/* BACK */}
      <button className="btn admin-back" onClick={() => navigate("/")}>
        ⬅ Back to Home
      </button>

      <h2>🌸 Admin Panel</h2>

      <div className="admin-form">

        <input
          type="text"
          placeholder="Enter Flower Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <input 
          type="file"
          onChange={(e) => setFile(e.target.files[0])}
        />

        <select value={category} onChange={(e) => setCategory(e.target.value)}>
          <option value="car">🚗 Car</option>
          <option value="wedding">💍 Wedding</option>
          <option value="puja">🪔 Puja</option>
        </select>

        <button className="btn" onClick={handleAdd}>
          {editIndex !== null ? "✏️ Update Flower" : "➕ Add Flower"}
        </button>

        <button 
          className="btn"
          style={{ background: "#6c63ff" }}
          onClick={handleGalleryUpload}
        >
          📸 Upload Gallery
        </button>
      </div>

      <h3>Added Flowers</h3>

      {flowers.map((f, index) => (
        <div key={index} style={{ margin: "10px" }}>
          {f.name}

          <button
            className="btn"
            style={{ marginLeft: "10px", background: "orange" }}
            onClick={() => {
              setName(f.name);
              setEditIndex(index);
            }}
          >
            ✏️ Edit
          </button>

          <button
            className="btn"
            style={{ marginLeft: "10px", background: "red" }}
            onClick={() => handleDelete(index)}
          >
            ❌ Delete
          </button>
        </div>
      ))}
    </div>
  );
};

export default Admin;